import { Link } from 'react-router-dom';

import { useAuth } from '../auth';

type PageHeroProps = {
  canAccessAdmin: boolean;
  contextLabel?: string;
  contextNote?: string | null;
  contextValue?: string;
  eyebrow: string;
  isAdminPage: boolean;
  selectedMemberName?: string | null;
  title: string;
  onSelectedMemberClick?: () => void;
};

function roleLabel(username: string | undefined) {
  if (username === 'cantabile-admin') {
    return 'Admin';
  }

  return 'Mitglied';
}

export function PageHero({
  canAccessAdmin,
  contextLabel,
  contextNote,
  contextValue,
  eyebrow,
  isAdminPage,
  selectedMemberName,
  title,
  onSelectedMemberClick,
}: PageHeroProps) {
  const { logout, user } = useAuth();

  return (
    <header className="hero public-head">
      <div className="hero-row">
        <div className="hero-brand-copy">
          <div className="brand-lockup">
            <img
              className="brand-logo"
              src="/branding/cantabile-logo.png"
              alt="Cantabile Dresden"
            />
            <div>
              <p className="eyebrow">{eyebrow}</p>
              <p className="brand-name">Cantabile Dresden</p>
            </div>
          </div>
          <h1>{title}</h1>
        </div>

        <div className="hero-sidebars">
          {contextLabel && contextValue ? (
            <div className="status-panel hero-context-panel">
              <span className="status-label">{contextLabel}</span>
              <strong>{contextValue}</strong>
              {contextNote ? <span>{contextNote}</span> : null}
            </div>
          ) : null}

          <div className="status-panel hero-user-panel">
            <span className="status-label">Aktueller Nutzer</span>
            <strong>{user?.username ?? '-'}</strong>
            <span className="hero-role-line">
              Rolle: {roleLabel(user?.username)}
            </span>
            {onSelectedMemberClick ? (
              <button
                type="button"
                className="identity-chip"
                aria-label={`Ich bin: ${selectedMemberName ?? 'Mitglied auswählen'}`}
                onClick={onSelectedMemberClick}
              >
                <span>Ich bin</span>
                <strong>{selectedMemberName ?? 'Mitglied auswählen'}</strong>
              </button>
            ) : null}
            <div className="actions hero-actions">
              {isAdminPage ? (
                <Link className="button-secondary" to="/">
                  Zur Startseite
                </Link>
              ) : canAccessAdmin ? (
                <Link className="button-secondary" to="/admin">
                  Zum Admin
                </Link>
              ) : null}
              <button
                type="button"
                className="button-secondary"
                onClick={() => void logout()}
              >
                Abmelden
              </button>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}
